import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {CommonService} from 'src/app/shared/utils/common.service';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {moduloConciliacionBan} from '../../diccionarios/conciliacionBancariaModulo';

@Injectable({
  providedIn: 'root'
})
export class InputSearchService {

  urlLocal: any;
  params: any;

  constructor(private http: HttpClient,
              private _commom: CommonService,
              private _util: UtilsService) {
    this.urlLocal = moduloConciliacionBan.url.conciliacionBancaria;
  }

  getClienteParams(codIni, codFin, rucIni, rucFin, nombre) {
    return this._commom.peticionGetConHeader(this._util.getDatosMaestros() + this.urlLocal.clienteFind
      + codIni + '&cliHasta=' + codFin + '&rucDesde=' + rucIni + '&rucHasta=' + rucFin + '&nombreLike='
      + nombre);
  }

}
